import styled from "styled-components";

export const FirebaseNotificationBody = styled.div`
    p {
        margin: 0;
    }
`